import React from 'react';
import { MapPin, Clock, Phone } from 'lucide-react';

const Visit = () => {
  return (
    <section id="visit" className="bg-[#f4ead4] pb-24 lg:pb-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="bg-[#ecdcbf] rounded-3xl p-8 sm:p-12 lg:p-16">
          <div className="grid lg:grid-cols-[1.2fr_1fr] gap-12 items-center">
            <div>
              <div className="text-[12px] tracking-[0.16em] font-medium text-[#b8532a] uppercase mb-5">
                Come on in
              </div>
              <h2 className="font-serif text-[44px] sm:text-[56px] lg:text-[64px] leading-[1.02] text-[#2a1a0f] tracking-tight">
                A warm seat, a good cup, and the time to enjoy both.
              </h2>

              <div className="mt-10 grid sm:grid-cols-2 gap-8">
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-full bg-[#f4ead4] border border-[#2a1a0f]/10 flex items-center justify-center flex-shrink-0">
                    <MapPin className="w-4 h-4 text-[#2a1a0f]" strokeWidth={1.8} />
                  </div>
                  <div>
                    <div className="text-[16px] text-[#2a1a0f]">462 B Anderson Dr</div>
                    <div className="text-[14px] text-[#7a5c40]">Quesnel, BC V2J 1G2</div>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-full bg-[#f4ead4] border border-[#2a1a0f]/10 flex items-center justify-center flex-shrink-0">
                    <Clock className="w-4 h-4 text-[#2a1a0f]" strokeWidth={1.8} />
                  </div>
                  <div>
                    <div className="text-[16px] text-[#2a1a0f]">Tuesday–Saturday</div>
                    <div className="text-[14px] text-[#7a5c40]">10:30 a.m.–6:30 p.m.</div>
                    <div className="text-[14px] text-[#2a1a0f] mt-3">Sunday & Monday</div>
                    <div className="text-[14px] text-[#7a5c40]">Closed</div>
                  </div>
                </div>
              </div>

              <div className="mt-10 flex items-center gap-3 flex-wrap">
                <a
                  href="tel:+12509927066"
                  className="inline-flex items-center gap-3 bg-[#b8532a] hover:bg-[#a34620] text-[#f4ead4] px-6 py-3.5 rounded-full transition-colors"
                >
                  <Phone className="w-4 h-4" strokeWidth={2} />
                  <span className="text-[15px] font-medium">Call (250) 992-7066</span>
                </a>
                <a
                  href="https://www.google.com/maps/dir/?api=1&destination=462+B+Anderson+Dr,+Quesnel,+BC+V2J+1G2"
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center gap-3 bg-[#f4ead4]/70 hover:bg-[#f4ead4] border border-[#2a1a0f]/15 text-[#2a1a0f] px-6 py-3.5 rounded-full transition-colors"
                >
                  <MapPin className="w-4 h-4" strokeWidth={2} />
                  <span className="text-[15px]">Get directions</span>
                </a>
                              </div>
            </div>

            <div className="flex justify-center">
              <div className="w-64 h-64 sm:w-80 sm:h-80 rounded-full bg-[#2a1a0f] flex flex-col items-center justify-center shadow-2xl">
                <span className="font-serif text-[68px] sm:text-[84px] text-[#f4ead4] leading-none">
                  Bliss!
                </span>
                <span className="text-[11px] tracking-[0.28em] text-[#c9b394] mt-4">
                  COFFEE · QUESNEL
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Visit;
